var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditRequirements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.91h1c.265 0 .52.106.707.295.188.19.293.446.293.714v7.071c0 .268-.105.525-.293.714A.995.995 0 0 1 11 13H5a.995.995 0 0 1-.707-.296A1.015 1.015 0 0 1 4 11.99V4.92c0-.269.105-.526.293-.715A.995.995 0 0 1 5 3.909h1",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3h-3c-.276 0-.5.204-.5.455v.909c0 .25.224.454.5.454h3c.276 0 .5-.203.5-.454v-.91C10 3.205 9.776 3 9.5 3z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRequirements);
export default __webpack_public_path__ + "static/media/editRequirements.7e11d20443273055cd42dd56419d3181.svg";
export { ForwardRef as ReactComponent };